export const GET_DISCREPANCY_STATS = gql`
  query GetDiscrepancyStats($filters: DiStatsFiltersInput) {
    documentIntelligenceDiscrepancyStats(filters: $filters) {
      cdlDocumentCount
      documentsWithDiscrepancies
      discrepancyRate
      applicantsInScope
      applicantsWithAnyDiscrepancy
      anyDiscrepancyRate
      cdlApplicantsInScope
      cdlApplicantsWithDiscrepancy
      cdlDiscrepancyRate
      medicalApplicantsInScope
      medicalApplicantsWithDiscrepancy
      medicalDiscrepancyRate
      byField {
        field
        count
      }
    }
  }
`

export const GET_MVR_DISCREPANCY_STATS = gql`
  query GetMvrDiscrepancyStats($filters: DiStatsFiltersInput) {
    documentIntelligenceMvrDiscrepancyStats(filters: $filters) {
      applicantsWithMvr
      incidentsCountMismatchCount
      suspensionMismatchCount
      anyMismatchCount
    }
  }
`

export const GET_MVR_DISCREPANCY_DOCUMENTS = gql`
  query GetMvrDiscrepancyDocuments($filters: DiStatsFiltersInput) {
    documentIntelligenceMvrDiscrepancyDocuments(filters: $filters) {
      documentId
      applicantId
      applicantName
      mismatchedFields
      fieldSources {
        field
        documentId
      }
      processedAt
    }
  }
`

export const GET_MVR_EXTRACTION_SUMMARY = gql`
  query GetMvrExtractionSummary($filters: DiStatsFiltersInput) {
    documentIntelligenceMvrExtractionSummary(filters: $filters) {
      accidentCount
      movingViolationCount
      nonMovingViolationCount
      suspensionCount
      disqualificationCount
      licenseActionCount
      medicalCertCount
    }
  }
`

export const GET_PSP_DISCREPANCY_STATS = gql`
  query GetPspDiscrepancyStats($filters: DiStatsFiltersInput) {
    documentIntelligencePspDiscrepancyStats(filters: $filters) {
      applicantsWithPsp
      incidentsCountMismatchCount
      anyMismatchCount
      totalCrashesFound
      totalViolationsFound
    }
  }
`

export const GET_PSP_DISCREPANCY_DOCUMENTS = gql`
  query GetPspDiscrepancyDocuments($filters: DiStatsFiltersInput) {
    documentIntelligencePspDiscrepancyDocuments(filters: $filters) {
      documentId
      applicantId
      applicantName
      mismatchedFields
      fieldSources {
        field
        documentId
      }
      processedAt
    }
  }
`

export const GET_PSP_EXTRACTION_SUMMARY = gql`
  query GetPspExtractionSummary($filters: DiStatsFiltersInput) {
    documentIntelligencePspExtractionSummary(filters: $filters) {
      crashCount
      inspectionCount
      violationCount
    }
  }
`

export const GET_DISCREPANCY_DOCUMENTS = gql`
  query GetDiscrepancyDocuments($filters: DiStatsFiltersInput) {
    documentIntelligenceDiscrepancyDocuments(filters: $filters) {
      documentId
      applicantId
      applicantName
      mismatchedFields
      fieldSources {
        field
        documentId
      }
      processedAt
    }
  }
`

export const GET_CORRECTED_DOCUMENTS = gql`
  query GetCorrectedDocuments($filters: DiStatsFiltersInput) {
    correctedDocuments(filters: $filters) {
      documentId
      category
      applicantId
      applicantName
      correctedFields
      createdAt
    }
  }
`

export const GET_PENDING_REVIEW_DOCUMENTS = gql`
  query GetPendingReviewDocuments($filters: DiStatsFiltersInput) {
    pendingReviewDocuments(filters: $filters) {
      documentId
      category
      applicantId
      applicantName
      pendingFields
      createdAt
    }
  }
`

export const GET_DOCUMENT_INTELLIGENCE_STATS = gql`
  query GetDocumentIntelligenceStats($filters: DiStatsFiltersInput) {
    documentIntelligenceStats(filters: $filters) {
      documentsProcessed
      totalPredictionsAllFields
      autoAppliedCount
      correctedCount
      correctionAfterAutoApplyRate
      pendingReviewCount

      volumeOverTime {
        date
        count
        categoryCount
        expirationCount
      }

      categoryBreakdown {
        categoryValue
        extracted
        autoApplied
        accepted
        awaiting
        dismissed
        corrections
        accuracyRate
      }

      expirationAutoApplied
      expirationAccepted
      expirationAwaiting
      expirationDismissed
      expirationCorrectedCount
      expirationAccuracyRate

      coreExpirationAutoApplied
      coreExpirationAccepted
      coreExpirationAwaiting
      coreExpirationDismissed
      coreExpirationCorrections

      byField {
        field
        totalPredictions
        autoAppliedCount
        acceptedCount
        rejectedCount
        correctedCount
      }
    }
  }
`
